import { createContext, useContext } from "react";

export const UgcLightCtx = createContext(false);
export const useUgcLight = () => useContext(UgcLightCtx);
